export default {

    Settings: 'الإعداد|الإعدادات',
};
